const BOOKIE_ICONS = {
  sportsbet: {
    initials: "SB",
    background: "#00BFFF",
    foreground: "yellow"
  },
  topsport: {
    initials: "TS",
    background: "#0008b8",
    foreground: "#ffffff"
  },
  bet365: {
    initials: "365",
    background: "#126e51",
    foreground: "yellow"
  },
  tabtouch: {
    initials: "TT",
    background: "#744093",
    foreground: "white"
  },
  playup: {
    initials: "PU",
    background: "#1A1A1A",
    foreground: "#00f181"
  },
  pointsbet: {
    initials: "PB",
    background: "#222",
    foreground: "#FF4444"
  },
  elitebet: {
    initials: "EB",
    background: "#f2d98f",
    foreground: "#191919"
  },
  sportsbetting: {
    initials: "SB",
    background: "#f47820",
    foreground: "white"
  },
  boombet: {
    initials: "BB",
    background: "#f69320",
    foreground: "white",
    border: "2px solid #ee3a6f"
  },
  southerncross: {
    initials: "SC",
    background: "#255FC8",
    foreground: "white"
  },
  tab: {
    initials: "TAB",
    background: "#008542",
    foreground: "white"
  },
  unibet: {
    initials: "UNI",
    background: "#147b45",
    foreground: "white"
  },
  winnersbet: {
    initials: "WB",
    background: "#552583",
    foreground: "#fdd023"
  },
  betdeluxe: {
    initials: "BD",
    background: "#222222",
    foreground: "#F37121"
  },
  robwaterhouse: {
    initials: "RW",
    background: "#6C19B1",
    foreground: "#FFFFFF"
  },
  bbet: {
    initials: "BB",
    background: "#084C8B",
    foreground: "#FF5C3E"
  },
  texbet: {
    initials: "TB",
    background: "#86CB2A",
    foreground: "#1C5693"
  },
  crossbet: {
    initials: "CB",
    background: "#111D2B",
    foreground: "#3D9C8C"
  },
  realbookie: {
    initials: "RB",
    background: "#CCCCCC",
    foreground: "#007881"
  },
  picnicbet: {
    initials: "PB",
    background: "#0C4DA2",
    foreground: "#EBA945"
  },
  bluebet: {
    initials: "BB",
    background: "#2D58B5",
    foreground: "white"
  },
  woodcock: {
    initials: "WC",
    background: "white",
    foreground: "#165fac",
    border: "2px solid #165fac"
  },
  lynchbet: {
    initials: "LB",
    background: "white",
    foreground: "#cd0016",
    border: "2px solid #cd0016"
  },
  davedwyer: {
    initials: "DD",
    background: "#9b8753",
    foreground: "white"
  },
  colossalbet: {
    initials: "CB",
    background: "black",
    foreground: "#e4bf75"
  },
  zbet: {
    initials: "ZB",
    background: "#050B3C",
    foreground: "#77AAF7"
  },
  moriarty: {
    initials: "Mo",
    background: "white",
    foreground: "#21768b",
    border: "2px solid #21768b"
  },
  jimmybet: {
    initials: "JB",
    background: "#7401A9",
    foreground: "white"
  },
  betright: {
    initials: "BR",
    background: "#eb00ff",
    foreground: "#01ff47"
  },
  gallopbet: {
    initials: "Ga",
    background: "white",
    foreground: "red",
    border: "2px solid black"
  },
  wishbet: {
    initials: "WB",
    background: "black",
    foreground: "yellow"
  },
  pendlebury: {
    initials: "Pe",
    background: "white",
    foreground: "darkorange",
    border: "2px solid black"
  },
  actionbet: {
    initials: "Ac",
    background: "yellow",
    foreground: "black",
    border: "2px solid black"
  },
  vicbet: {
    initials: "VB",
    background: "#00319a",
    foreground: "white"
  },
  topodds: {
    initials: "TO",
    background: "white",
    foreground: "#597091",
    border: "2px solid #d98310"
  },
  betm: {
    initials: "BM",
    background: "white",
    foreground: "rgb(47 154 229)",
    border: "2px solid rgb(47 154 229)"
  },
  readybet: {
    initials: "RB",
    background: "rgb(34, 40, 109)",
    foreground: "white"
  },
  marantelli_bet: {
    initials: "MB",
    background: "rgb(49, 44, 109)",
    foreground: "rgb(254, 71, 71)"
  },
  aussie_wagering: {
    initials: "AW",
    background: "#161d51",
    foreground: "#97d8f2"
  },
  puntondogs: {
    initials: "POD",
    background: "#f6ff00",
    foreground: "#007bff"
  },
  swiftbet: {
    initials: "SB",
    background: "rgb(19, 39, 75)",
    foreground: "#62C7F2"
  },
  tombet: {
    initials: "TB",
    background: "#0081d4",
    foreground: "white"
  },
  betnation: {
    initials: "BN",
    background: "rgb(0, 38, 79)",
    foreground: "rgb(20, 217, 255)"
  },
  betr: {
    initials: "betr",
    background: "#093AD4",
    foreground: "#84FEE5"
  },
  sportchamps: {
    initials: "SC",
    background: "#26639C",
    foreground: "#FFA000"
  },
  picklebet: {
    initials: "PB",
    background: "rgb(21, 32, 37)",
    foreground: "#4fd130"
  },
  foxcatcher: {
    initials: "FC",
    background: "rgb(20, 68, 112)",
    foreground: "white"
  },
  mintbet: {
    initials: "MB",
    background: "rgb(38, 209, 125)",
    foreground: "rgb(0, 77, 66)"
  },
  chasebet: {
    initials: "CB",
    background: "rgb(139, 63, 164)",
    foreground: "white"
  },
  betgalaxy: {
    initials: "BG",
    background: "rgb(70, 78, 139)",
    foreground: "rgb(62, 220, 228)"
  },
  baggybet: {
    initials: "BB",
    background: "rgb(53, 53, 72)",
    border: "2px solid rgb(253, 118, 62)",
    foreground: "rgb(253, 118, 62)"
  },
  punterspal: {
    initials: "PP",
    background: "rgb(30, 33, 47)",
    border: "2px solid rgb(43, 155, 199)",
    foreground: "rgb(43, 155, 199)"
  },
  goldbet: {
    initials: "GB",
    background: "#070707",
    border: "2px solid rgb(254, 202, 18)",
    foreground: "rgb(254, 202, 18)"
  },
  budgetbet: {
    initials: "BB",
    background: "#0b5c31",
    foreground: "white"
  },
  wellbet: {
    initials: "WB",
    background: "rgb(51, 118, 166)",
    foreground: "white"
  },
  vinbet: {
    initials: "VB",
    background: "black",
    border: "2px solid gold",
    foreground: "gold"
  },
  bossbet: {
    initials: "BB",
    background: "rgb(0, 159, 253)",
    border: "2px solid red",
    foreground: "yellow"
  }
};

const BOOKIE_DESCRIPTIONS = {
  betfair: "Betfair",
  bet365: "Bet365",
  elitebet: "EliteBet",
  playup: "PlayUp",
  pointsbet: "PointsBet",
  southerncross: "Southern Cross",
  sportsbet: "Sportsbet",
  sportsbetting: "SportsBetting",
  boombet: "BoomBet",
  tab: "TAB",
  tabtouch: "TABtouch",
  topsport: "TopSport",
  unibet: "Unibet",
  winnersbet: "WinnersBet",
  betdeluxe: "BetDeluxe",
  robwaterhouse: "Rob Waterhouse",
  bbet: "BBet",
  texbet: "TexBet",
  crossbet: "CrossBet",
  realbookie: "RealBookie",
  picnicbet: "PicnicBet",
  bluebet: "BlueBet",
  woodcock: "Woodcock",
  lynchbet: "LynchBet",
  colossalbet: "ColossalBet",
  davedwyer: "Dave Dwyer",
  zbet: "ZBet",
  moriarty: "Moriarty",
  jimmybet: "JimmyBet",
  betright: "BetRight",
  gallopbet: "GallopBet",
  wishbet: "WishBet",
  pendlebury: "Pendlebury",
  actionbet: "ActionBet",
  vicbet: "VicBet",
  topodds: "TopOdds",
  betm: "BetM",
  readybet: "Readybet",
  marantelli_bet: "Marantelli Bet",
  aussie_wagering: "Aussie Wagering",
  puntondogs: "Punt On Dogs",
  swiftbet: "SwiftBet",
  tombet: "TomBet",
  betnation: "BetNation",
  betr: "betr",
  sportchamps: "SportChamps",
  picklebet: "Picklebet",
  foxcatcher: "Foxcatcher",
  mintbet: "MintBet",
  betgalaxy: "BetGalaxy",
  baggybet: "BaggyBet",
  wellbet: "WellBet",
  chasebet: "ChaseBet",
  bossbet: "BossBet"
};

export default {
  BOOKIE_ICONS,
  BOOKIE_DESCRIPTIONS
};
